// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1kmSn","sendOtp":"AuthorizeToLogin_sendOtp__3UrKU"};